import logo from "./logo.svg";
import "./App.css";
import { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
 Navigate,
 useParams
} from "react-router-dom";
import Barnav from "./components/Frontend1/barnav/Barnav";
import { hamburguesas, drinks, desserts } from "./Variables";
import React from "react";
// import Admin from "./components/AdminFrontend/Admin";
import Error from "./components/Error";

import Home from "./components/Home";

// import ChatUser from './components/ChatUser'




function Service16({ api16, ip1,  consoleAdmin, setConsoleAdmin, securityAdmin, setSecurityAdmin, setVisibilityClientFrontend, visibilityClientFrontend, setBarnavState}) {
 
  

  return (
    
      <div className="App">
       {/* <React.Fragment>
        <Home />
       </React.Fragment> */}
{/* RENDERIZADO CENTRAL DE LA APLICACION */}
        <Routes>
        {/* <Route path="/"  /> */}
       

          <Route path="/service1/:tableNumber/error" element={<Error  setVisibilityClientFrontend={setVisibilityClientFrontend}/>} />
          <Route path="/:tableNumber" element={<Home ip1={ip1} api16={api16} setBarnavState={setBarnavState}  setConsoleAdmin={setConsoleAdmin} consoleAdmin={consoleAdmin} securityAdmin={securityAdmin} setSecurityAdmin={setSecurityAdmin} visibilityClientFrontend={visibilityClientFrontend} setVisibilityClientFrontend={setVisibilityClientFrontend} />}  />
        </Routes>
      </div>
  );
}

export default Service16;
